import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function openEnrollmentPickup(id: number) {
  return restApiClient
    .url(constructApiUrl(API.enrollments.openEnrollmentPickup.url, { id }))
    .post()
}
